import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import util from "../util/util";
import LoadingIndicatorText from "../loading-indicator/loading-indicator-text";
import InaccessibleLink from "../shim/inaccessible-link";

const jQuery = window.jQuery;

export default function InviteListTable(props) {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered table-hover">
        <colgroup>
          <col style={{ width: `1%` }}></col>
          <col style={{ width: `35%` }}></col>
          <col style={{ width: `35%` }}></col>
          <col style={{ width: `18%` }}></col>
          <col style={{ width: `11%` }}></col>
        </colgroup>
        <thead>
          <tr>
            <th>#</th>
            <th>Email</th>
            <th>Role</th>
            <th>{renderSortLink(`has_accepted`, `Accepted`)}</th>
            <th>Remove Invite</th>
          </tr>
        </thead>
        <tbody>
          {props.invites === false ? (
            <tr>
              <td>
                <strong>0</strong>
              </td>
              <td colSpan="5">{util.zeroInvitesMessage}</td>
            </tr>
          ) : null}

          {props.invites && props.invites.length === 0 ? (
            <tr>
              <td colSpan="6">
                <LoadingIndicatorText />
              </td>
            </tr>
          ) : null}

          {props.invites && props.invites.length
            ? props.invites.map((invite, index) => {
                return index < util.inviteResultsPerPage ? (
                  <tr key={index}>
                    <td>
                      <strong>
                        {util.returnLineNumber(
                          props.currentPage,
                          util.inviteResultsPerPage,
                          index
                        )}
                      </strong>
                    </td>
                    <td>{invite.email || <em>N/A</em>}</td>
                    <td>{invite.group ? invite.group.name : <em>N/A</em>}</td>
                    <td>
                      {invite.has_accepted ? (
                        `Yes`
                      ) : (
                        <div>
                          No -{" "}
                          <Link to={util.returnInviteFormUrl(invite.id)}>
                            Resend
                          </Link>
                        </div>
                      )}
                    </td>
                    <td>
                      <InaccessibleLink
                        className="text-danger"
                        onClick={() => props.onClickDeleteInvite(invite)}
                      >
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                      </InaccessibleLink>
                    </td>
                  </tr>
                ) : null;
              })
            : null}
        </tbody>
      </table>
    </div>
  );

  // display table header sort links;
  function renderSortLink(sortValue, sortDisplay) {
    const className = util.returnSortClass(sortValue, props.sort);
    const newSortValue = util.returnSortValue(sortValue, props.sort);
    const queryStringObject = props.queryString
      ? jQuery.deparam(props.queryString.replace(`?`, ``))
      : {};

    // add the new sort value to the querystring object;
    queryStringObject.sort = newSortValue;

    return (
      <Link
        to={`${util.returnInviteListUrl()}?${jQuery.param(queryStringObject)}`}
        className={className}
      >
        {sortDisplay}
        <i className="fa fa-sort-desc" aria-hidden="true"></i>
        <i className="fa fa-sort-asc" aria-hidden="true"></i>
      </Link>
    );
  }
}

InviteListTable.propTypes = {
  currentPage: PropTypes.number, // used to calc the # in the TABLE;
  onClickDeleteInvite: PropTypes.func, // remove invite from station;
  invites: PropTypes.oneOfType([
    // invite data to display;
    PropTypes.array,
    PropTypes.bool
  ])
};
